import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { CheckoutFeedbackQuestionType } from "../../../../../../../projection/checkoutFeedback/checkoutFeedback.constants";
import { DOMAIN } from "../../../../../i18n/i18n";
import { CheckoutQuestionItem } from "../CheckoutQuestionItem";
import { style as hostDefaultCheckoutQuestionItemStyle } from "./HostDefaultCheckoutQuestionItem.style";

const HostDefaultCheckoutQuestionItem: CheckoutQuestionItem<CheckoutFeedbackQuestionType.HOST_DEFAULT> = ({
  checkoutQuestion,
  children,
}) => {
  const titleText = useI18nMessage({ domain: DOMAIN, id: checkoutQuestion.translationKey });

  const style = useMemo(() => hostDefaultCheckoutQuestionItemStyle(), []);

  return (
    <>
      <Text level={3} style={style.title}>
        {titleText}
      </Text>
      <View style={style.content}>{children}</View>
    </>
  );
};

export { HostDefaultCheckoutQuestionItem };
